module.exports = __webpack_public_path__ + "img/success.1f6af9cd.svg";